// extracted by mini-css-extract-plugin
export default {"login":"styles_login__l+xve","splitter":"styles_splitter__SYKMa","forgotPassword":"styles_forgotPassword__oSWxz","footer":"styles_footer__3y9y-","error":"styles_error__4xKlb"};